import { restClient } from '@/Core'

/**
 * Відновити корені кошика: `POST /services/disk/trash/restore`. Бек повертає
 * вузол у вихідну папку, а якщо її вже немає — у корінь простору.
 */
export const RestoreDiskNodesTask = async (nodes: string[]): Promise<void> => {
    await restClient.post('/services/disk/trash/restore', { json: { nodes } })
}
